import RewardCard from 'ai/components/SuperChat/RewardCard/RewardCard';
import { withRewardCardProps } from 'ai/viewModel/superChat/rewardCard/withRewardCardProps';

export default withRewardCardProps(RewardCard);
